import {
  CLEAR_STRATEGY,
  FETCH_STRATEGY,
  FETCH_STRATEGY_FAIL,
  LOADING_STRATEGY,
  PATCH_STRATEGY,
  PATCH_STRATEGY_FAIL,
} from "./actionTypes";

const initialState = {
  id: 0,
  name: "",
  activity: "",
  useAssistant: false,
  useLearning: false,
  vision: "",
  goal: "",
  success: "",
  mission: "",
  image: "",
  swots: [],
  nextCodir: "",
  message: "",
  status: 0,

  isLoading: true,
};

const strategyReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_STRATEGY:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_STRATEGY:
      return {
        ...state,
        id: action.payload.id,
        name: action.payload.name,
        activity: action.payload.activity,
        useAssistant: action.payload.useAssistant,
        useLearning: action.payload.useLearning,
        vision: action.payload.vision,
        goal: action.payload.goal,
        success: action.payload.success,
        mission: action.payload.duty,
        image: action.payload.image,
        swot: action.payload.swot,
        nextCodir: action.payload.nextCodir,
        message: action.payload.message,
        status: action.payload.status,
        isLoading: false,
      };
    case PATCH_STRATEGY: {
      return {
        ...state,
        name: action.payload.name,
        nextCodir: action.payload.nextCodir,
        message: action.payload.message,
        status: action.payload.status,
        isLoading: false,
      };
    }
    case FETCH_STRATEGY_FAIL:
      return {
        ...state,
        message: action.message,
        status: action.status,
        isLoading: false,
      };
    case PATCH_STRATEGY_FAIL:
      return {
        ...state,
        message: action.message,
        status: action.payload.status,
        isLoading: false,
      };
    case CLEAR_STRATEGY:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default strategyReducer;
